import httpClient from '@/apis/base/httpclient';
import DIApi from './_diApi';

class LocationApi extends DIApi {
  controllerName = 'locations';

  /**
   * Lấy dữ liệu danh sách các tỉnh
   * NVXUAN 02.06.2023
   */
  async getAllProvince() {
    return await this.getLocationByKind(1);
  }

  /**
   * Lấy dữ liệu danh sách các huyện
   * NVXUAN 02.06.2023
   */
  async getAllDistrict() {
    return await this.getLocationByKind(2);
  }

  /**
   * Lấy dữ liệu danh sách các xã
   * NVXUAN 02.06.2023
   */
  async getAllCommunee() {
    return await this.getLocationByKind(3);
  }

  /**
   * Lấy location theo kind
   * @param {number} kind 1. Tỉnh/thành phố | 2. Quận/huyện | 3. Xã/Phường
   * @returns
   */
  async getLocationByKind(kind) {
    const request = {
      url: this.getAPIUrl() + '/getLocationByKind?kind=' + kind,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách location theo parentID
   * @param {object} param
   * @return
   * NVXUAN 02.06.2023
   */
  async getLocationByParentID(parentID) {
    const request = {
      url: this.getAPIUrl() + '/findByParent',
      data: parentID,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách thông tin đơn vị theo mã
   * @param {object} param
   * @return
   * @author nvthinh 31.05.2024
   */
  async getTenantInfoListByProvince(provinceCode) {
    const request = {
      url: this.getAPIUrl() + '/TenantInfoListByProvince',
      data: {provinceCode},
    };

    return await httpClient.getAsync(request);
  }
}

export default new LocationApi();
